import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Main.css";

import Image1 from "../imgs/0001.jpg";
import Image2 from "../imgs/0002.jpg";
import Image3 from "../imgs/0003.jpg";
import Image4 from "../imgs/0004.jpg";
import RoomImage1 from "../imgs/room1.jpg";
import RoomImage2 from "../imgs/room2.jpg";
import RoomImage3 from "../imgs/room3.jpg";
import GoogleMapImage from "../imgs/googlemap.jpg";

function Main() {
  const navigate = useNavigate();

  const topRef = useRef(null);
  const aboutSectionRef = useRef(null);
  const roomSectionRef = useRef(null);
  const activitySectionRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isBookingMenuOpen, setIsBookingMenuOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleImageClick = () => {
    navigate("/gallery");
  };

  const handleJpClick = () => {
    navigate("/jp");
  }

  const handleEnClick = () => {
    navigate("/");
  };

  const images = [
    { src: Image1, alt: "Room view" },
    { src: Image2, alt: "Outside view" },
    { src: Image3, alt: "Dining area" },
    { src: Image4, alt: "Bed room" },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuItemClick = (ref) => {
    setIsMenuOpen(false);
    if (ref.current) {
      const offset = 80;
      const elementPosition = ref.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div>
      <div ref={topRef}></div>

      <header className="header">
        <div id="top" className="logo" onClick={() => handleMenuItemClick(topRef)}>
          NAKAYAMA VILLA
        </div>
        <button className="menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? "✖" : "☰"}
        </button>
        <nav className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
          <ul className="menu-list">
            <li>
              <a href="#about" onClick={() => handleMenuItemClick(aboutSectionRef)}>お宿について</a>
            </li>
            <li>
              <a href="#rooms" onClick={() => handleMenuItemClick(roomSectionRef)}>お部屋について</a>
            </li>
            <li>
              <a href="#access" onClick={() => handleMenuItemClick(activitySectionRef)}>アクセスについて</a>
            </li>
            <li>
              <a href="" onClick={handleImageClick}>ギャラリーを見る</a>
            </li>
            <li>
              <a href="https://www.booking.com/Share-3IdcLz" target="_blank" rel="noopener noreferrer">Booking.com</a>
            </li>
            <li>
              <a href="https://www.airbnb.jp/rooms/1335947108229180506?guests=1&adults=1&s=67&unique_share_id=9a5fd18c-b849-48f4-8382-b99a6d57e886" target="_blank" rel="noopener noreferrer">Airbnb</a>
            </li>
          </ul>
        </nav>
        <div className="language-button">
          <a href="/" onClick={handleEnClick}>EN</a>
        </div>
      </header>

      <main>
        <div id="" className="carousel-container">
          <section className="description">
            <p>広島高速馬木ICすぐそばの贅沢空間 <br />～心地よい長期滞在と優雅なひとときを～</p>
          </section>

          <div className="carousel">
            {images.map((image, index) => (
              <div key={index} className={`carousel-item ${index === currentIndex ? "active" : ""}`}>
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        </div>

        <section id="about" className="about" ref={aboutSectionRef}>
          <h3>お宿について</h3>
          <p>庭の景色を望む中山宿 Nakayama Villa</p>
          <p>車移動に便利な広島高速すぐそば165平米の贅沢空間</p>
          <p>庭と無料専用駐車場を提供</p>
          <p>無料駐車場に充電スタンド有り</p>
          <p>テラスとバルコニーを提供する宿泊施設</p>
          <p>Ikejiri Children's Parkまで約3km</p>
          <p>イオンモール広島府中まで約2.6km</p>
          <p>ようこそ NAKAYAMA VILLA へ</p>
          <a
            href="https://www.booking.com/Share-3IdcLz"
            target="_blank"
            rel="noopener noreferrer"
            className="about-button"
          >
            NAKAYAMA VILLA
          </a>
        </section>

        <section id="rooms" className="room-section" ref={roomSectionRef}>
          <p className="room-title-en">Rooms</p>
          <h2 className="room-title">安らぎの空間</h2>
          <div className="room-images">
            <div className="room-image-large">
              <img src={RoomImage1} alt="Room Large View" />
            </div>
            <div className="room-image-small">
              <img src={RoomImage2} alt="Room Bedroom" />
              <img src={RoomImage3} alt="Room Tea Set" />
            </div>
          </div>
          <div className="room-description">
            <h3>お部屋について</h3>
            <p>
              寝室は3室・最大8名様までご宿泊いただけます
              <br />
              家族旅行やグループでの滞在におすすめ
              <br />
              無料駐車場に加え調理道具や洗濯機も完備
              <br />
              電気自動車用の充電スタンドも無料で利用可能
              <br />
              和室の居間から望む行き届いた美しい庭園
              <br />
              心を落ち着かせる癒しのひとときを
              <br />
              高速光回線のインターネットが使い放題
              <br />
              動画配信サービスもお楽しみいただけます
            </p>
            <a
              href="https://www.booking.com/Share-3IdcLz"
              target="_blank"
              rel="noopener noreferrer"
              className="about-button"
            >
              お宿のご予約はこちら
            </a>
          </div>
        </section>

        <section id="access" className="access" ref={activitySectionRef}>
          <p className="access-title-en">Access</p>
          <h2 className="access-title">交通路線</h2>
          <div className="access-content">
            <div className="access-map">
              <img src={GoogleMapImage} alt="Access Map" />
            </div>
            <div className="access-text">
              <p>
                広島高速馬木インターチェンジからすぐのアクセス抜群の立地にある、敷地200㎡超の豪華な旅館です。
                車移動に便利な広島高速すぐそば165平米の贅沢空間。無料駐車場に充電スタンド有り。
                広島駅まで3.3km、Sorajoyama Parkまで3.5kmです。広島空港まで43kmです。
                これらは徒歩10分圏内の施設になります。
                <br />
                <br />
                <a>① Nakayama Villa</a>
                <br />
                <a href="https://map.yahoo.co.jp/v3/place/cZucn2l6pGU">② 稲生神社（高台にあり眺めよし）</a>
                <br />
                <a href="https://ameblo.jp/hirodai-kouko/entry-12869328129.html">③ 中山貝塚　</a>
                <a href="https://drive.google.com/file/d/1YUpBW5ybwl8SEKqItvb3wKCqUW2S9axX/view?usp=sharing">（詳細）</a>
                <br />
                <a href="https://www.hiroshimapeacemedia.jp/?p=123829">④ 萬休寺</a>
                <br />
                <a href="https://www.joysound.com/web/shop/detail/123106">⑤ カラオケ（ビリー・ザ・キッド）</a>
                <br />
                <a>⑥ コンビニ（LAWSON）</a>
                <br />
                <a href="https://tabelog.com/hiroshima/A3401/A340104/34021384/">⑦ 焼き鳥屋（カープ鳥）</a>
                <br />
                <a href="https://himawarinews.com/store/nakayama_pharmacy/">⑧ 薬局（スーパードラッグひまわり）</a>
                <br />
                <a>⑨ 郵便局</a>
                <br />
                <a href="https://tabelog.com/hiroshima/A3401/A340104/34025036/">⑩ お好み焼き（絆心）</a>
                <br />
                <a href="https://tokubai.co.jp/%E3%82%B9%E3%83%91%E3%83%BC%E3%82%AF/10670">⑪ スーパーマーケット(SPARK)</a>
                <br />
                <a href="https://www.foleo.jp/hiroshimahigashi/index.html">⑫ ショッピングモール（フォレオ広島東）</a>
                <br />
                <a href="https://drive.google.com/file/d/1RzfvGbtGpLnud5CVeuVsnG3t8avWsixc/view?usp=sharing">⑬ 新幹線車両基地</a>
                <br />
              </p>
              <a href="" onClick={handleImageClick} className="access-button">
                MORE INFO
              </a>
            </div>
          </div>
        </section>

      </main>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-center">
            <div className="footer-address">
              <h3>NAKAYAMA VILLA</h3>
              <p>〒732-0023</p>
              <p>広島県・広島市・東区中山東3丁目8-3</p>
              <p>© NAKAYAMA VILLA</p>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <a href="#">TOP</a>
              <a href="#about">ABOUT US</a>
              <a href="#rooms">ROOMS</a>
              <a href="#access">ACCESS</a>
              <a href="" onClick={handleImageClick}>GALLERY</a>
              <a href="https://www.booking.com/Share-3IdcLz" target="_blank" rel="noopener noreferrer" onClick={() => handleMenuItemClick(roomSectionRef)}>BOOKING</a>
            </div>
            <div className="footer-column">
              <a href="jp" onClick={handleJpClick}>Japanese</a>
              <a href="" onClick={handleEnClick}>English</a>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
}

export default Main;
